import { useMemo } from "react";

import { useDocumentMetadata } from "~/state";

import { useEasel } from "../easel";

export const useCurrentDocument = () => {
	const easel = useEasel();

	const documentId = useMemo(() => easel.documentId, [easel]);

	const data = useDocumentMetadata(documentId);

	return data ?? null;
};
